import { ChangeDetectionStrategy, Component, OnInit, computed, effect, inject, input, signal } from '@angular/core';
import { GalaxyColumnDef, GalaxyDataSource, Row } from '@vendasta/galaxy/table';
import { ActivityLeaderboardDatasource } from './activity-leaderboard.datasource';
import { toSignal } from '@angular/core/rxjs-interop';
import { Sort, MatSort, MatSortHeader } from '@angular/material/sort';
import { DateRange, UserActivity } from './interfaces';
import { GalaxyTableModule } from '@vendasta/galaxy/table';
import {
  MatTable,
  MatHeaderRowDef,
  MatHeaderRow,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatFooterCellDef,
  MatFooterCell,
  MatRowDef,
  MatRow,
  MatFooterRowDef,
  MatFooterRow,
} from '@angular/material/table';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { DecimalPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

type FooterType = 'total' | 'average';

@Component({
  selector: 'crm-activity-leaderboard',
  templateUrl: './activity-leaderboard.component.html',
  styleUrls: ['./activity-leaderboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    GalaxyTableModule,
    MatTable,
    MatSort,
    MatHeaderRowDef,
    MatHeaderRow,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatFooterCellDef,
    MatFooterCell,
    MatSortHeader,
    GalaxyAvatarModule,
    GalaxyFormFieldModule,
    MatSelect,
    FormsModule,
    MatOption,
    MatRowDef,
    MatRow,
    MatFooterRowDef,
    MatFooterRow,
    DecimalPipe,
    TranslateModule,
  ],
})
export class ActivityLeaderboardComponent implements OnInit {
  activityDatasource = inject(ActivityLeaderboardDatasource);
  selection = input<DateRange>();

  columns: GalaxyColumnDef[] = [
    {
      id: 'rank',
      title: 'LEADERBOARD.COLUMNS.RANK',
    },
    {
      id: 'name',
      title: 'LEADERBOARD.COLUMNS.NAME',
      pinned: true,
      sticky: true,
    },
    {
      id: 'inboundCall',
      title: 'LEADERBOARD.COLUMNS.INBOUND_CALLS',
    },
    {
      id: 'outboundCall',
      title: 'LEADERBOARD.COLUMNS.OUTBOUND_CALLS',
    },
    {
      id: 'inboundEmail',
      title: 'LEADERBOARD.COLUMNS.INBOUND_EMAILS',
    },
    {
      id: 'outboundEmail',
      title: 'LEADERBOARD.COLUMNS.OUTBOUND_EMAILS',
    },
    {
      id: 'meeting',
      title: 'LEADERBOARD.COLUMNS.MEETINGS',
    },
  ];
  tableColumns = this.columns.map((c) => c.id);

  dataSource = new GalaxyDataSource<UserActivity, DateRange, Sort>(this.activityDatasource);
  selectedRows: Row[] = [];

  footerType = signal<FooterType>('total');
  private footerTotal = toSignal(this.activityDatasource.total$$);
  private footerAverage = toSignal(this.activityDatasource.average$$);
  footerData = computed(() => {
    const type = this.footerType();
    const total = this.footerTotal();
    const average = this.footerAverage();
    return type === 'total' ? total : average;
  });

  constructor() {
    effect(() => {
      const selection = this.selection();
      this.dataSource.setFilters([selection]);
    });
  }

  ngOnInit(): void {
    this.dataSource.setFilters([]);
  }

  protected sortChange(sort: Sort): void {
    this.dataSource.setSorting([sort]);
  }
}
